import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const links = [
  { to: "/server", label: "Server" },
  { to: "/assistant", label: "Assistant" },
  { to: "/compliance", label: "Compliance" },
  { to: "/standard", label: "Standard" },
  { to: "/company", label: "Company" },
];

export const SiteHeader = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`site-header${scrolled ? " scrolled" : ""}${open ? " mobile-open" : ""}`}
    >
      <div className="site-header-inner">
        <Link to="/" className="site-header-logo" aria-label="Bancony — home">
          <img src="/bancony300.svg" alt="Bancony" height={32} width={128} />
        </Link>

        <button
          type="button"
          className="site-header-toggle"
          aria-label="Open navigation"
          aria-expanded={open}
          onClick={() => setOpen((v) => !v)}
        >
          <span className="site-header-toggle-bar" aria-hidden="true" />
        </button>

        <nav className="site-header-nav" aria-label="Primary">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `site-header-link${isActive ? " active" : ""}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <Link to="/contact?intent=demo" className="site-header-cta">
          Book a demo
        </Link>
      </div>
    </header>
  );
};
